import { LayoutContextProps } from '@interfaces/Contexts';
import React from 'react';

export const LayoutContext = React.
    createContext<LayoutContextProps>({} as LayoutContextProps);
